export default __webpack_public_path__ + "static/media/flayerA.115dbc10.jpg";